import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './GitHubRepositories.css';

const GitHubRepositories = () => {
  const [repos, setRepos] = useState([]);

  useEffect(() => {
    const accessToken = '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';
    const apiUrl = 'https://api.github.com/user/repos';

    axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setRepos(response.data);
      })
      .catch((error) => {
        console.error('Error fetching GitHub repositories:', error);
      });
  }, []);

  return (
    <div className="github-repositories">
      <h2 className="section-title">GitHub Repositories</h2>
      <ul className="repo-list">
        {repos.map((repo) => (
          <li key={repo.id} className="repo-item">
            <a
              href={repo.html_url}
              target="_blank"
              rel="noopener noreferrer"
              className="repo-link"
            >
              {repo.name}
            </a>
            <p className="repo-description">{repo.description}</p>
            <div className="repo-details">
              <span className="language">{repo.language}</span>
              <span className="stars">
                <svg
                  className="octicon octicon-star"
                  viewBox="0 0 16 16"
                  width="16"
                  height="16"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.05 1.44a1.5 1.5 0 012.4 1.54l-.69 4.18 2.93 3.03a1.5 1.5 0 11-2.18 2.06L8 10.36 5.49 12.25a1.5 1.5 0 11-2.18-2.06l2.93-3.03-.69-4.18a1.5 1.5 0 012.4-1.53z"
                  ></path>
                </svg>
                {repo.stargazers_count}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GitHubRepositories;
